import styled from 'styled-components';

const FooterSlider = styled.div`
  border-radius: 5px;
`;

export default FooterSlider;
